import apiClient from '../api/apiClient'; // Import the centralized apiClient
import API_ENDPOINTS from '../api/endpoint';

export const loginUser = async (data) => {
  return apiClient.post(API_ENDPOINTS.AUTH.LOGIN, data);
};

export const logoutUser = async () => {
  return apiClient.post(API_ENDPOINTS.AUTH.LOGOUT);
};

export const registerUser = async (data) => {
  return apiClient.post(API_ENDPOINTS.AUTH.REGISTER, data);
};

export const deleteAccount = async () => {
  try {
    const response = await apiClient.delete(API_ENDPOINTS.AUTH.DELETE_ACCOUNT);
    return response.data;
  } catch (error) {
    console.error('Error deleting account:', error.response?.data || error.message);
    throw error;
  }
};

export const forgotPassword = async (data) => {
  try {
    const response = await apiClient.post(
      API_ENDPOINTS.AUTH.FORGOT_PASSWORD,
      data
    );
    return response.data;
  } catch (error) {
    console.error(
      'Error sending reset link:',
      error.response?.data || error.message
    );
    throw error;
  }
};

// Reset password with token, uid, role, and new password
export const resetPassword = async (data) => {
  try {
    const response = await apiClient.post(
      API_ENDPOINTS.AUTH.RESET_PASSWORD,
      data
    );
    return response.data;
  } catch (error) {
    console.error(
      'Error resetting password:',
      error.response?.data || error.message
    );
    throw error;
  }
};